module.exports = __webpack_public_path__ + "img/coupon-download.ebad9024.png";